<template>
  <div class="pr-layout h100">
    <aside-bar></aside-bar>
    <div class="pr-main h100">
      <header-bar></header-bar>
      <article class="pr-content">
        <transition name="fade-transform" mode="out-in">
          <router-view :key="key" />
        </transition>
      </article>
    </div>
  </div>
</template>

<script>
import asideBar from '@/components/asideBar'
import headerBar from '@/components/headerBar'
export default {
  name: 'Layout',
  components: { asideBar, headerBar },
  mixins: [],
  computed: {
    key() {
      return this.$route.path
    }
  },
  created() {
    // console.log('二级路由入口layout ---- $route.path----------', this.$route, this.$route.path)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.pr-main {
  margin-left: 210px;
}
.pr-content {
  height: calc(100% - 50px);
  box-sizing: border-box;
  background: #fff;
}
</style>
